import { RouteObject } from 'react-router-dom';
import AuthGuard from '../guards/AuthGuard';
import DashboardLayout from '@/layouts/DashboardLayout';
import { lazyRetry } from '@/utils/lazyRetry';
import PermissionGuard from '../guards/PermissionGuard';
import { routePermissions } from '../../constants/permissionMap';

export const dashboardRoutes: RouteObject = {
    element: <AuthGuard />,
    children: [
        {
            path: '/dashboard',
            element: <DashboardLayout />,
            children: [
                {
                    id: "dashboard",
                    path: "statistics",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/dashboard/pages/DashboardPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.dashboard.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "customers",
                    path: "customers",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/customer/pages/CustomerPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.customers.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "categories",
                    path: "categories",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/category/pages/CatgeoryPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.categories.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "features",
                    path: "features",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/feature/pages/FeaturePage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.features.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "requests",
                    path: "requests",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/PendingPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-request",
                    path: "requests/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "accepted",
                    path: "accepted",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/AcceptedPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.cartTracking.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-accepted",
                    path: "accepted/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "rejected",
                    path: "rejected",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/RejectedPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-rejected",
                    path: "rejected/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "canceled",
                    path: "canceled",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/CanceledPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-canceled",
                    path: "canceled/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "ontheway",
                    path: "ontheway",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/OnTheWayPage.tsx"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.cartTracking.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-ontheway",
                    path: "ontheway/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "delivered",
                    path: "delivered",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/DeliveredPage.tsx"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.cartTracking.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-delivered",
                    path: "delivered/:order",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/cart/pages/ViewCartPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.carts.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "offers",
                    path: "offers",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/offer/pages/OfferPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.offers.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "coupons",
                    path: "coupons",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/coupon/pages/CouponPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.coupons.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "contact-requests",
                    path: "contact-requests",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/contact/pages/ContactPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.contacts.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "blogs",
                    path: "blogs",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/blog/pages/BlogPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.blogs.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "add-blog",
                    path: "blogs/add",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/blog/pages/FormBlogPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.blogs.create}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "edit-blog",
                    path: "blogs/:blog/edit",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/blog/pages/FormBlogPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.blogs.edit}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "view-blog",
                    path: "blogs/:blog",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/blog/pages/ViewBlogPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.blogs.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "newsletter-subscriptions",
                    path: "newsletter-subscriptions",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/newsletter/pages/NewsletterPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.newsLetter.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "special-requests",
                    path: "special-requests",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/special-request/pages/SpecialRequestPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.specialRequests.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "payment-links",
                    path: "payment-links",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/payment-link/pages/PaymentLinkPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.paymentLinks.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "payment-methods",
                    path: "payment-methods",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/payment-method/pages/PaymentMethodPages"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.paymentMethods.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "clients",
                    path: "clients",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/company/pages/CompanyPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.companyCustomers.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "company-info",
                    path: "company-info",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/company/pages/CompanyInfoPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.companyInfo.view}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "sliders",
                    path: "sliders",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/slider/pages/SliderPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.sliders.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "banners",
                    path: "banners",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/banner/pages/BannerPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.banners.create}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    path: "distributors",
                    children: [
                        {
                            index: true,
                            id: "distributors-list",
                            lazy: async () => {
                                const module = await lazyRetry(() => import("@/views/modules/distributors/pages/DistributorsList"));
                                return { element: <module.default /> };
                            },
                        },
                        {
                            id: "distributor-details",
                            path: ":id",
                            lazy: async () => {
                                const module = await lazyRetry(() => import("@/views/modules/distributors/pages/DistributorDetails"));
                                return { element: <module.default /> };
                            },
                        }
                    ]
                },
                {
                    path: "distributor-applications",
                    children: [
                        {
                            index: true,
                            id: "distributor-applications-list",
                            lazy: async () => {
                                const module = await lazyRetry(() => import("@/views/modules/distributors/pages/DistributorApplicationsList"));
                                return { element: <module.default /> };
                            },
                        },
                        {
                            id: "distributor-application-review",
                            path: ":id",
                            lazy: async () => {
                                const module = await lazyRetry(() => import("@/views/modules/distributors/pages/DistributorApplicationReview"));
                                return { element: <module.default /> };
                            },
                        }
                    ]
                },

                // {
                //     id: "permissions",
                //     path: "permissions",
                //     lazy: async () => {
                //         const module = await lazyRetry(() => import("@/views/modules/user-management/permissions/pages/PermissionPage"));
                //         return {
                //             element: (
                //                 <PermissionGuard requiredPermissions={routePermissions.superAdmin.all}>
                //                     <module.default />
                //                 </PermissionGuard>
                //             )
                //         };
                //     },
                // },
                {
                    id: "roles",
                    path: "roles",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/user-management/roles/pages/RolePage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.superAdmin.all}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "users",
                    path: "users",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/user-management/users/pages/UserPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.users.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "products",
                    path: "products",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/product/pages/ProductPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.products.list}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "add-product",
                    path: "products/add",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/product/pages/AddProductPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.products.create}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "edit-product",
                    path: "products/:product/edit",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/product/pages/AddProductPage"));
                        return {
                            element: (
                                <PermissionGuard requiredPermissions={routePermissions.products.edit}>
                                    <module.default />
                                </PermissionGuard>
                            )
                        };
                    },
                },
                {
                    id: "forbidden",
                    path: "forbidden",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/ForbiddenPage"));
                        return { element: <module.default /> };
                    },
                },
                {
                    id: "tickets",
                    path: "tickets",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/tickets/pages/TicketPage"));
                        return {
                            element: (
                                <module.default />
                            )
                        };
                    },
                },
                {
                    id: "storehouse",
                    path: "storehouse",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/modules/storehouse/pages/StorehousePage"));
                        return { element: <module.default /> };
                    },
                },
                {
                    id: "notifications",
                    path: "notifications",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/notifications/pages/NotificationPage"));
                        return { element: <module.default /> };
                    },
                },
                {
                    id: "send-notification",
                    path: "notifications/send-notification",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/notifications/pages/SendNotificationPage"));
                        return { element: <module.default /> };
                    },
                },
            ],
        },
    ],
};